module.exports = __webpack_public_path__ + "images/application/i-delete-light-b69700b1.svg";